import { Component, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { PIN_OPTIONAL_PREFIX_REG } from './utility/app.utils';
import { UtilityService } from './utility/utility.service';
import { MatDialog } from '@angular/material/dialog';
import { WebClientHealthCheckComponent } from './cms/common/dialogs/web-client-health-check/web-client-health-check.component';
import { Subscription } from 'rxjs';
import { UIEventEnum } from './utility/amplitude-tracking/tracking.types';
import { TrackingService } from './utility/amplitude-tracking/tracking.service';

@Component({
  selector: 'qa-link-shortener',
  template: ``,
  styles: [``],
})
export class ShortenerComponent {
  private utility = inject(UtilityService);
  private matDialog = inject(MatDialog);
  sub: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public matSnackBar: MatSnackBar,
    private translator: TranslateService,
    private tracker: TrackingService
  ) {
    const targetId = this.activatedRoute.snapshot.params.anyid;
    const routesMap: Record<string, string> = {
      l: 'live-events',
      e: 'exam',
      c: 'course',
      b: 'book',
    };
    const match = targetId.match(PIN_OPTIONAL_PREFIX_REG);
    if (match) {
      const prefixChar = match[2].toLowerCase();
      if (routesMap[prefixChar]) {
        const isPrefixPresent = !!match[1];
        if (isPrefixPresent || environment.edition !== 'webclient') {
          this.router.navigate([routesMap[prefixChar], targetId]).then(() => {
            this.checkForWebClientHealth();
          });
          return;
        }
      }
    }
    this.matSnackBar.open(this.translator.instant('findContent.invalidPin'));
    this.router.navigateByUrl('/');
  }

  hasStorageIssue() {
    const isStorageAvailable =
      this.utility.isStorageAvailable('localStorage') ||
      this.utility.isStorageAvailable('sessionStorage');
    return !isStorageAvailable;
  }

  checkForWebClientHealth() {
    if (this.hasStorageIssue()) {
      this.tracker.trackEvent({
        event_type: UIEventEnum.LIMITATIONS_DETECTED,
      });
      this.openWebClientHealthCheckDialog();
    }
  }

  openWebClientHealthCheckDialog() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    const dialog = this.matDialog.open(WebClientHealthCheckComponent);
    this.sub = dialog.afterClosed().subscribe({
      next: (shouldCheckAgain) => {
        if (shouldCheckAgain) {
          this.checkForWebClientHealth();
        }
      },
    });
  }
}
